import React from "react";
import { FormikType } from "../../../../types/types";
import { InitialAuditionStateType } from "../../../../assets/data/initialState";
import { useIASelector } from "../../../../redux/hooks";
import {
  selectedCompanyTypeFilterSelector,
  selectedCompanyTypeFiltersSelector,
} from "../../../../redux/slices/companyTypeFiltersSlice";
import CustomModal from "../../CustomModal";
import { Dialog } from "@headlessui/react";
import ModalHeader from "../../headers/ModalHeader";
import CustomButton from "../../buttons/CustomButton";
import CompanyTypeFilterModalCompanyTypeFilters from "./CompanyTypeFilterModalCompanyTypeFilters";
import CompanyTypeFilterModalSelectedTypeFilters from "./CompanyTypeFilterModalSelectedTypeFilters";
import CompanyTypeFilterModalEdit from "./CompanyTypeFilterModalEdit";

type Props = FormikType<InitialAuditionStateType> & {
  isOpen: boolean;
  closeModal: () => void;
};

export default function CompanyTypeFilterModal({
  closeModal,
  formik,
  isOpen,
}: Props) {
  const selectedCompanyTypeFilters = useIASelector(
    selectedCompanyTypeFiltersSelector
  );

  const handleSetCompanyTypeFilters = () => {
    formik.setFieldValue("companyTypeFilters", selectedCompanyTypeFilters);
    closeModal();
  };

  return (
    <CustomModal isOpen={isOpen} closeModal={closeModal}>
      <Dialog.Panel className="relative bg-white rounded-lg w-1/2">
        <ModalHeader
          title="Company Type"
          description="Edit, add and manage this Audition’s Company Type."
          closeModal={closeModal}
        />
        <div className="grid grid-cols-modal px-4 h-full">
          <div className="h-4/5 w-full justify-between flex flex-col">
            <div className="w-full grid grid-cols-auditionType">
              <CompanyTypeFilterModalCompanyTypeFilters formik={formik} />
              <CompanyTypeFilterModalSelectedTypeFilters formik={formik} />
            </div>
            <div className="flex-row flex items-center justify-start my-4">
              <CustomButton
                className="medium-black-button mr-2"
                text="Set Location Tags"
                onClick={() => handleSetCompanyTypeFilters()}
              />
              <CustomButton
                className="medium-white-button"
                text="Cancel"
                onClick={closeModal}
              />
            </div>
          </div>
          <CompanyTypeFilterModalEdit formik={formik} />
        </div>
      </Dialog.Panel>
    </CustomModal>
  );
}
